import { render } from "./HeroiconsOutlineArrowUp.vue?vue&type=template&id=34ac6f60"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowUp.vue"]])

export default __exports__